export default __webpack_public_path__ + "static/media/cargo.d94ef101.jpg";